const CONTENT_PATH_PATTERN = /^\/(articles|policies|webinars|use-cases|solutions|features|alternative|blog)\/([^/?#]+)/

const CONTENT_PATH_TO_MANIFEST_KEY = {
  articles: 'article',
  policies: 'policy',
  webinars: 'webinar',
  'use-cases': 'use-cases',
  solutions: 'solutions',
  features: 'features',
  alternative: 'alternative',
}

const hasNzVariant = (pathname, nzSlugs) => {
  const match = pathname.match(CONTENT_PATH_PATTERN)
  if (!match) return true
  const [, prefix, slug] = match
  // Blog category pages have no NZ variant: `/nz/blog/<category>` 404s (only the
  // `/nz/blog` index exists). So never prefix blog links with `/nz`.
  if (prefix === 'blog') return false
  const key = CONTENT_PATH_TO_MANIFEST_KEY[prefix]
  // Manifest shape is { <type>: { nz: [...], au: [...] } }; the NZ variants drive prefixing.
  const available = nzSlugs?.[key]?.nz
  return Array.isArray(available) && available.includes(slug)
}

const extractPathname = (href) => {
  if (!href) return ''
  if (href.startsWith('/')) return href
  if (href.startsWith('https://elker.com')) return href.slice('https://elker.com'.length) || '/'
  return ''
}

export const useSanitize = (html, locale) => {
  if (!html) return null

  const nzSlugsState = useState('nzSlugs', () => null)
  const nzSlugs = nzSlugsState.value
  const baseUrls = ['https://elker.com']
  const regex = /<a\s+([^>]*?)>/gi

  const updatedHtml = html.replace(regex, (match, attrs) => {
    const hrefMatch = attrs.match(/href\s*=\s*(['"])(.*?)\1/i)
    const href = hrefMatch ? hrefMatch[2] : ''
    const isLocal = href.startsWith('/') || baseUrls.some((baseUrl) => href.startsWith(baseUrl))
    const hasTargetAttr = attrs.match(/target\s*=\s*(['"]).*?\1/i)

    const pathname = extractPathname(href)
    const shouldPrefixNz = locale === 'nz' && !pathname.startsWith('/nz') && hasNzVariant(pathname, nzSlugs)

    if (isLocal) {
      if (shouldPrefixNz) {
        attrs = attrs.replace(/href\s*=\s*(['"])(\/.*?)(\1)/i, 'href="/nz$2"')
      } else {
        attrs = attrs.replace(/target\s*=\s*(['"]).*?\1/i, '')
      }
    } else if (!hasTargetAttr) {
      attrs += ' target="_blank" rel="dofollow"'
    }

    if (href.startsWith('https://elker.com')) {
      if (shouldPrefixNz) {
        attrs = attrs.replace(/href\s*=\s*(['"])(https:\/\/elker\.com)(.*?)\1/i, 'href="/nz$3"')
      } else {
        attrs = attrs.replace(/href\s*=\s*(['"])(https:\/\/elker\.com)(.*?)\1/i, 'href="$3"')
      }
    }

    if (isLocal && href.endsWith('/')) {
      attrs = attrs.replace(/href\s*=\s*(['"])(.*?)\/\1/i, 'href="$2"')
    }

    return `<a ${attrs}>`
  })

  return updatedHtml
}
